import "../../../App.css";
import { Container } from "react-bootstrap";
import LogoCenter from "../components/LogoCenter";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BlankSpace from "../components/BlankSpace";
import BottomNav from "../components/BottomNav";
import DrawerRight from "../components/DrawerRight";
import { Grid, Container as Cont } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Box, IconButton } from "@mui/material";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import { ChevronLeft } from "@mui/icons-material";
import { Skeleton } from "@mui/material";
import TransactionsTable from "../components/TransactionsTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchAndUpdateMealBalance, formatMealBalance } from "utils/mealBalance";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const serverId = process.env.REACT_APP_SERVER_ID;
const siteId = process.env.REACT_APP_SITE_ID;
const storeId = process.env.REACT_APP_STORE_ID;
const enableRevenueCenter = process.env.REACT_APP_ENABLE_REVENUE_CENTER;
const buttonColor = process.env.REACT_APP_BUTTON_COLOR;
const buttonText = process.env.REACT_APP_BUTTON_TEXT;
const colorBackground = process.env.REACT_APP_BACKGROUND_COLOR;

export const Transactions = () => {
  const history = useHistory();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [
    { customerId, customerDetails },
    setCookieSICName,
    removeCookieSICName,
  ] = useCookies(["customerList"]);
  const [servingPeriod, setServingPeriod] = useState([]);
  const [revenueCenter, setRevenueCenter] = useState([]);
  const [menuName, setMenuName] = useState([]);
  const [selectedRevenueCenter, setSelectedRevenueCenter] = useState(
    state?.revenueCenter || "none"
  );
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get meal balance from Redux store
  const { mealBalance, mealBalanceDollars } = useSelector((state) => state.cart);
  const mBalance = formatMealBalance(mealBalanceDollars);

  // console.log(customerDetails, "customerDetails");

  const getTransactions = useCallback(async () => {
    if (!customerId) {
      history.push("/");
      return;
    }

    try {
      const { data } = await axios.get(
        `${apiBaseURL}/customer/transaction-history/${serverId}/${siteId}/${customerDetails?.CustomerNumber}`
      );

      const filteredData = data.filter(
        (item) => item.CustomerNumber === customerDetails.CustomerNumber
      );

      console.log(filteredData);
      setTransactions(filteredData);
    } catch (error) {
      console.error("Error getting transactions:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedRevenueCenter, customerId]);

  useEffect(() => {
    getTransactions();
  }, [getTransactions]); // Dependency array includes getTransactions to ensure it's called only once when the component mounts.

  // Fetch meal balance on component mount
  useEffect(() => {
    const loadMealBalance = async () => {
      const firstName = customerDetails?.FirstName;
      const roomNumber = customerDetails?.Address1 || customerDetails?.CustomerNumber;

      if (firstName && roomNumber) {
        await fetchAndUpdateMealBalance(
          dispatch,
          firstName,
          roomNumber,
          apiBaseURL,
          serverId,
          siteId,
          storeId
        );
      }
    };

    if (customerDetails) {
      loadMealBalance();
    }
  }, [dispatch, customerDetails]);

  const handleGoBack = () => {
    history.push("/");
  };

  return (
    <div
      className="Welcome modal-container"
      style={{
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <LogoCenter
        selectedRevenueCenter={selectedRevenueCenter}
        hasUserInfo={false}
      />
      <BlankSpace />
      <DrawerRight />

      <Container
        fluid
        className="welcomeCustom"
        style={{
          maxWidth: "100%",
          padding: "0 8px",
          "@media (min-width: 85px)": {
            padding: "0 12px",
          },
          "@media (min-width: 576px)": {
            padding: "0 16px",
            maxWidth: "540px",
          },
          "@media (min-width: 768px)": {
            padding: "0 20px",
            maxWidth: "720px",
          },
          "@media (min-width: 992px)": {
            padding: "0 24px",
            maxWidth: "960px",
          },
          "@media (min-width: 1200px)": {
            padding: "0 32px",
            maxWidth: "1140px",
          },
          "@media (max-width: 190px)": {
            padding: "0 4px",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            margin: "0 auto",
          }}
        >
          <Cont
            maxWidth={false}
            sx={{
              padding: { xs: 1, sm: 1.5, md: 2, lg: 2.5 },
              width: "100%",
              maxWidth: {
                xs: "100%",
                sm: "540px",
                md: "720px",
                lg: "960px",
                xl: "1140px",
              },
              margin: "0 auto",
              "@media (max-width: 190px)": {
                padding: "4px",
              },
            }}
          >
            {/* <Box
              sx={{
                marginBottom: { xs: 0.5, sm: 1 },
                "@media (max-width: 190px)": {
                  marginBottom: "2px",
                },
              }}
            >
              <IconButton
                onClick={handleGoBack}
                sx={{
                  padding: { xs: 0.5, sm: 1 },
                  "@media (max-width: 190px)": {
                    padding: "2px",
                    "& .MuiSvgIcon-root": {
                      fontSize: "1rem",
                    },
                  },
                  backgroundColor: buttonColor,
                  color: buttonText,
                  boxShadow: { xs: "none", sm: "0 2px 4px rgba(0,0,0,0.1)" },
                  ":hover": { backgroundColor: colorBackground },
                }}
              >
                <ChevronLeft
                  sx={{
                    fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.75rem" },
                  }}
                />
              </IconButton>
            </Box> */}
            <Grid
              container
              spacing={{ xs: 1, sm: 1.5, md: 2 }}
              sx={{
                "@media (max-width: 190px)": {
                  flexDirection: "column",
                  "& > .MuiGrid-item": {
                    width: "100%",
                    maxWidth: "100%",
                  },
                },
              }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  "@media (max-width: 190px)": {
                    marginBottom: 1,
                  },
                }}
              >
                <Box marginTop={{ xs: 1, sm: 1.5, md: 2 }}>
                  <Typography
                    fontWeight={200}
                    sx={{
                      fontSize: {
                        xs: "1rem",
                        sm: "1.125rem",
                      },
                      "@media (max-width: 190px)": {
                        fontSize: "0.75rem",
                      },
                      lineHeight: "normal",
                    }}
                  >
                    {loading ? (
                      <Skeleton
                        width="100%"
                        sx={{
                          fontSize: {
                            xs: "1rem",
                            sm: "1.125rem",
                          },
                          marginBottom: 1,
                          maxWidth: { xs: "100%", sm: 400, md: 700 },
                        }}
                      />
                    ) : (
                      <span>
                        Hello,{" "}
                        <b className="logoAmount">
                          {customerDetails.FirstName}
                        </b>
                        !
                      </span>
                    )}
                  </Typography>
                  <Typography
                    fontWeight={200}
                    sx={{
                      fontSize: {
                        xs: "1rem",
                        sm: "1.125rem",
                      },
                      "@media (max-width: 190px)": {
                        fontSize: "0.75rem",
                      },
                      lineHeight: "normal",
                    }}
                  >
                    {loading ? (
                      <Skeleton
                        width="100%"
                        sx={{
                          fontSize: {
                            xs: "1rem",
                            sm: "1.125rem",
                          },
                          marginBottom: 1,
                          maxWidth: { xs: "100%", sm: 400, md: 700 },
                        }}
                      />
                    ) : (
                      <span>
                        You have{" "}
                        <b className="logoAmount">{transactions.length}</b>{" "}
                        transactions
                      </span>
                    )}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box marginTop={{ xs: 1, sm: 1.5, md: 2 }}>
                  {loading ? (
                    <Skeleton
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.125rem" },
                        marginBottom: 1,
                        width: "100%",
                      }}
                    />
                  ) : (
                    <Typography
                      fontWeight={500}
                      sx={{
                        fontSize: {
                          xs: "1rem",
                          sm: "1.125rem",
                        },
                        "@media (max-width: 190px)": {
                          fontSize: "0.75rem",
                        },
                        wordBreak: "break-word",
                        lineHeight: "normal",
                        textAlign: { xs: "left", sm: "right" },
                      }}
                    >
                      Current Balance:{" "}
                      <b className="logoAmount">
                        ${mBalance}
                      </b>
                    </Typography>
                  )}
                  {loading ? (
                    <Skeleton
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.125rem" },
                        marginBottom: 1,
                        width: "100%",
                      }}
                    />
                  ) : (
                    <Typography
                      fontWeight={500}
                      sx={{
                        fontSize: {
                          xs: "1rem",
                          sm: "1.125rem",
                        },
                        "@media (max-width: 190px)": {
                          fontSize: "0.75rem",
                        },
                        wordBreak: "break-word",
                        lineHeight: "normal",
                        textAlign: { xs: "left", sm: "right" },
                      }}
                    >
                      Billable Amount:{" "}
                      <b className="logoAmount">
                        ${((customerDetails?.SIC_BillableAmount || 0) / 100).toFixed(2)}
                      </b>
                    </Typography>
                  )}
                  {loading ? (
                    <Skeleton
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.125rem" },
                        marginBottom: 1,
                        width: "100%",
                      }}
                    />
                  ) : (
                    <Typography
                      fontWeight={500}
                      sx={{
                        fontSize: {
                          xs: "1rem",
                          sm: "1.125rem",
                        },
                        "@media (max-width: 190px)": {
                          fontSize: "0.75rem",
                        },
                        wordBreak: "break-word",
                        lineHeight: "normal",
                        textAlign: { xs: "left", sm: "right" },
                      }}
                    >
                      Meal Credit Available:{" "}
                      <b className="logoAmount">{mealBalance} </b>
                    </Typography>
                  )}
                  {/* Change the Legend for Meal Plan Type based on ID here */}
                  {loading ? (
                    <Skeleton
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.125rem" },
                        width: "100%",
                      }}
                    />
                  ) : (
                    <Typography
                      fontWeight={500}
                      sx={{
                        fontSize: {
                          xs: "1rem",
                          sm: "1.125rem",
                        },
                        "@media (max-width: 190px)": {
                          fontSize: "0.75rem",
                        },
                        wordBreak: "break-word",
                        lineHeight: "normal",
                        textAlign: { xs: "left", sm: "right" },
                      }}
                    >
                      Meal Plan Type:{" "}
                      <b className="logoAmount">
                        {customerDetails.MealPlanName === "" ? (
                          <span>Default</span>
                        ) : (
                          <span>{customerDetails.MealPlanName}</span>
                        )}
                      </b>
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: { xs: 1, sm: 1.125, md: 1.25 },
                padding: { xs: 1, sm: 1.125, md: 1.25 },
                background: colorBackground,
                width: "100%",
                overflow: "hidden",
                "@media (max-width: 190px)": {
                  padding: "4px",
                  marginTop: "4px",
                },
                borderRadius: { xs: 1, sm: 2 },
                boxShadow: {
                  xs: "none",
                  sm: "0 2px 4px rgba(0,0,0,0.1)",
                },
              }}
            >
              {loading ? (
                <div>
                  <Skeleton
                    height={{ xs: 60, sm: 80, md: 100 }}
                    sx={{ marginBottom: 1 }}
                  />
                  <Skeleton
                    height={{ xs: 50, sm: 60, md: 80 }}
                    sx={{ marginBottom: 1 }}
                  />
                  <Skeleton
                    height={{ xs: 50, sm: 60, md: 80 }}
                    sx={{ marginBottom: 1 }}
                  />
                  <Skeleton
                    height={{ xs: 50, sm: 60, md: 80 }}
                    sx={{ marginBottom: 1 }}
                  />
                  <Skeleton
                    height={{ xs: 50, sm: 60, md: 80 }}
                    sx={{ marginBottom: 1 }}
                  />
                  <Skeleton height={{ xs: 50, sm: 60, md: 80 }} />
                </div>
              ) : (
                <Box
                  sx={{
                    overflowX: "auto",
                    width: "100%",
                    "@media (max-width: 190px)": {
                      fontSize: "0.7rem",
                    },
                  }}
                >
                  <TransactionsTable transactions={transactions} />
                </Box>
              )}
            </Box>
          </Cont>
        </Box>
      </Container>
      <BottomNav sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }} />
    </div>
  );
};
